export enum APP_ROUTES {
  TESTS = 'tests',
  NEW_TEST = 'tests/new',
  TESTS_LIST = 'tests/list',
  HELP_SUPPORT = '/help-support',
  HOME = 'home',
  TEST_RESULTS = 'test-results',
  SETTINGS = 'settings',
  CONTACT = 'contact',
  HELP = 'help',
  PATIENT_REPORT = 'reports',
  SU = 'su',
}

export const ONBOARDING_ROUTES = {
  REGISTER: 'register',
  MAGIC_LINK: 'magic-link',
  MAGIC_LINK_SENT: 'magic-link-sent',
  VERIFY: 'verify',
  MAGIC_LINK_EXPIRED: 'magic-link-expired',
  COMPLETE_PROFILE: 'complete-profile',
  LOGIN: 'login',
  FORGOT_PASSWORD: 'forgot-password',
  RESET_PASSWORD: 'reset-password',
};
